export default __webpack_public_path__ + "flaggedNoBorder.svg?5a75cdece2f63eba8d51cf09f37b3371";